import { PrimaryButton } from "../primaryButton/primaryButton";
import "./card.scss";

//HausanschlussComp und ErzeugungsanlageComp importieren diese Komponente
export default function Card(props: {
  topicSVG: any;
  headline: String | undefined;
  text: String | undefined;
  buttonFunction: Function;
  item: string;
}) {
  return (
    <div className={props.item}>
      <article className="gno-card">
        <div className="gno-svgElement">
          <div className="gno-topic-svg" data-testid="topicSVG">{props.topicSVG}</div>
        </div>
        <div className="gno-card-container">
          <p className="gno-card-headline">{props.headline}</p>
          <p className="gno-card-text">{props.text}</p>
          <div className="gno-card-button-container"> 
            <PrimaryButton
              negative={true}
              text="Mehr erfahren"
              function={props.buttonFunction}
            />
          </div>
        </div>
      </article>
    </div>
  );
}
